import { Box, Button, HStack } from '@chakra-ui/react';
import { NavLink, useLocation } from 'react-router';

export const AdminNav = () => {
  const location = useLocation();

  const adminNavItems = [
    { name: 'Portal Stats', path: '/admin/portal/stats' },
    { name: 'Airdrop Summary', path: '/admin/airdrop/summary' },
    { name: 'Points Compare', path: '/admin/points/compare' },
    // Add more admin nav items here as needed
  ];

  return (
    <Box mb={6} pb={4} borderBottom="1px solid" borderColor="gray.200">
      <HStack gap={4} wrap="wrap">
        {adminNavItems.map((item) => (
          <NavLink key={item.path} to={item.path}>
            <Button
              variant={location.pathname === item.path ? 'solid' : 'outline'}
              colorScheme={location.pathname === item.path ? 'blue' : 'gray'}
              size="md"
            >
              {item.name}
            </Button>
          </NavLink>
        ))}
      </HStack>
    </Box>
  );
};
